import * as R from 'ramda';

const updatePlacementSponsorAssociation = store => async (
    state,
    { rhId, plId, sponsors },
) => {
    const userClientId = state.user.selectedUserClientId;
    const rhIndex = state.clients[
        userClientId
    ].settings.client.onboarding.rightsholders.findIndex(rh => rh.id === rhId);
    const plIndex = state.clients[
        userClientId
    ].settings.client.onboarding.rightsholders[rhIndex].placements.findIndex(
        pl => pl.id === plId,
    );

    const sponsorLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
        plIndex,
        'sponsors',
    ]);

    store.setState(R.set(sponsorLens, sponsors, store.getState()), true);
};

export default updatePlacementSponsorAssociation;
